<!-- /* [NT-SEARCH-COMP-TAB] 기업회원 검색 */ -->

<template>
  <div class="networkSearch">
    <section>
      <div class="inner row3_1 flex mobileFlexCol">
        <article class="wd100">
          <h1 class="mainTitle">
            네트워킹 검색
          </h1>

          <NetworkSearchFilterCorp />

          <h5 class="networkSearch__headline">총 2544개 기업</h5>
          <div class="networkSearchList">
            <div class="networkSearchItem" v-for="item in items" :key="item">
              <figure class="networkSearchItemImage">
                <img src="/images/manager/matching/tec.png" alt="미국 국기" />
              </figure>
              <div class="networkSearchItemText">
                <h3 class="networkSearchItemTitle">(주)행복을 만드는 사람들</h3>
                <h5 class="networkSearchItemDesc">고령친화 의료기기 산업</h5>
                <div
                  style="text-align: center; padding-top: 32px; display: flex; gap: 1rem;"
                >
                  <button
                    class="networkSearchItemButton"
                    style="flex: 1;"
                    @click="
                      closeModal(), (isShowViewProfileCompanyPopup = true)
                    "
                  >
                    프로필 보기
                  </button>
                  <button
                    class="networkSearchItemButton"
                    style="flex: 1;background-color: #26336A; color: #FFFFFF; border: 0;"
                    @click="onShowApply"
                  >
                    신청/자문하기
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div>
            <PaginationMatching />
          </div>
        </article>
      </div>
    </section>

    <ViewProfileCompanyPopup
      :isModal="isShowViewProfileCompanyPopup"
      :handleToggleModal="closeModal"
      :handleOk="onShowApply"
    />

    <NTApplyPopup
      :isModal="isShowNTApplyPopup"
      :handleToggleModal="closeModal"
      :onApply="onApply"
      :onRequest="onRequest"
    />

    <NTApplyComPopup
      :isModal="isShowNTApplyComPopup"
      :handleToggleModal="closeModal"
    />

    <NTApplyNAPPopup
      :isModal="isShowNTApplyNAPPopup"
      :handleToggleModal="closeModal"
    />
  </div>
</template>

<script>
import PaginationMatching from "@/components/general/PaginationMatching.vue";
import NetworkSearchFilterCorp from "@/components/formControl/NetworkSearchFilterCorp.vue";
import ViewProfileCompanyPopup from "./popup/ViewProfileCompanyPopup.vue";
import NTApplyPopup from "./popup/NTApplyPopup.vue";
import NTApplyComPopup from "./popup/NTApplyComPopup.vue";
import NTApplyNAPPopup from "./popup/NTApplyNAPPopup.vue";

export default {
  name: "SearchCorporateMembers",
  data() {
    return {
      items: Array.from({ length: 12 }, (_, index) => index + 1),
      isShowViewProfileCompanyPopup: false,
      isShowNTApplyPopup: false,
      isShowNTApplyComPopup: false,
      isShowNTApplyNAPPopup: false,
    };
  },
  components: {
    NetworkSearchFilterCorp,
    PaginationMatching,
    ViewProfileCompanyPopup,
    NTApplyPopup,
    NTApplyComPopup,
    NTApplyNAPPopup,
  },

  methods: {
    closeModal() {
      this.isShowViewProfileCompanyPopup = false;
      this.isShowNTApplyPopup = false;
      this.isShowNTApplyComPopup = false;
      this.isShowNTApplyNAPPopup = false;
    },
    onShowApply() {
      this.closeModal();
      this.isShowNTApplyPopup = true;
    },
    onApply() {
      this.closeModal();
      this.isShowNTApplyComPopup = true;
    },
    onRequest() {
      this.closeModal();
      this.isShowNTApplyNAPPopup = true;
    },
  },
};
</script>

<style lang="scss" scoped>
// section 2
.directMatching {
  display: flex;
  border-bottom: 1px solid #d6d6d6;
  justify-content: space-between;
}

// Section 2

.btn-outlined {
  height: 53px;
  border: 1px solid #989898;
  background-color: #fff;
  width: 100%;
  font-size: 22px;
  margin-top: 16px;
  cursor: pointer;
}
</style>
